/* eslint-disable max-lines-per-function */
import { useMutation } from '@apollo/client/react';
import {
  ARBEITSZEITANTRAG_ABLEHNEN,
  ARBEITSZEITANTRAG_GENEHMIGEN,
} from './graphql/mutation';
import {
  ArbeitszeitantragAblehnenMutation,
  ArbeitszeitantragAblehnenMutationVariables,
  ArbeitszeitantragGenehmigenMutation,
  ArbeitszeitantragGenehmigenMutationVariables,
} from '@/gql/graphql';
import { toast } from '@/hooks/use-toast';
import { useNavigate, useParams } from 'react-router-dom';

export function useAntraegeUpdate() {
  const navigate = useNavigate();
  const { day, year, month } = useParams();
  const [ablehnenMutation, { loading: ablehnenLoading, error: ablehnenError }] =
    useMutation<
      ArbeitszeitantragAblehnenMutation,
      ArbeitszeitantragAblehnenMutationVariables
    >(ARBEITSZEITANTRAG_ABLEHNEN);

  const [
    genehmigenMutation,
    { loading: genehmigenLoading, error: genehmigenError },
  ] = useMutation<
    ArbeitszeitantragGenehmigenMutation,
    ArbeitszeitantragGenehmigenMutationVariables
  >(ARBEITSZEITANTRAG_GENEHMIGEN);

  const ablehnen = async (input: {
    idAntrag: string;
    idManagerVorgesetzter: string;
    bemerkungVorgesetzter: string;
  }) => {
    const result = await ablehnenMutation({
      variables: {
        input: {
          idAntrag: input.idAntrag,
          idManagerVorgesetzter: input.idManagerVorgesetzter,
          bemerkungVorgesetzter: input.bemerkungVorgesetzter,
        },
      },
      refetchQueries: [
        'getArbeitszeitenByDateAndStandortId',
        'GetToDos',
        'GetBenachrichtigungen',
      ],
      awaitRefetchQueries: true,
      onCompleted: () => {
        toast({
          title: 'Antrag bearbeitet',
          description: 'Der Antrag wurde abgelehnt.',
        });
        navigate(`/arbeitszeiten/uebersicht/${year}/${month}/${day}`);
      },
    });
    return result.data.arbeitszeitantragAblehnen;
  };

  const genehmigen = async (input: {
    idAntrag: string;
    idManagerVorgesetzter: string;
    bemerkungVorgesetzter?: string;
  }) => {
    const result = await genehmigenMutation({
      variables: {
        input: {
          idAntrag: input.idAntrag,
          idManagerVorgesetzter: input.idManagerVorgesetzter,
          bemerkungVorgesetzter: input.bemerkungVorgesetzter,
        },
      },
      refetchQueries: [
        'getArbeitszeitenByDateAndStandortId',
        'GetToDos',
        'GetBenachrichtigungen',
      ],
      awaitRefetchQueries: true,
      onCompleted: () => {
        toast({
          title: 'Antrag bearbeitet',
          description: 'Der Antrag wurde genehmigt.',
        });
        navigate(`/arbeitszeiten/uebersicht/${year}/${month}/${day}`);
      },
    });
    return result.data.arbeitszeitantragGenehmigen;
  };

  return {
    ablehnen,
    genehmigen,
    loading: ablehnenLoading || genehmigenLoading,
    error: ablehnenError || genehmigenError,
  };
}
